import config from "@/config";

export async function deleteConsent(policySetId: string, authorization: string) {
  const url = `${config.r4.consent}/${policySetId}`;

  const response = await window.fetch(encodeURI(url), {
    method: "DELETE",
    headers: {
      Authorization: authorization,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to delete consent");
  }
}
